// Use full path with a domain for static resources
// This is needed to resolve paths of dynamic imports
// eslint-disable-next-line camelcase, no-undef, no-underscore-dangle

// @ts-ignore
const environment: any = window.__ENV_CONFIG__ || {};

__webpack_public_path__ = environment.staticBaseUrl;
